var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduationsIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 979.98491 733.06747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "study") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M947.7,366.3v156.4l37.7,43.2L913,628.6l-66.2-62.7,39.8-44.3V392.2c-213.9,87.2-271.8,114.4-319.2,135.5-47.4,21.2-81.6,21.1-128.6,3.5-47-17.5-260.3-98.4-371.5-151-74.2-35.1-79-57.4,1.3-87.2,104.7-39.4,267.2-102.4,359-136.8,54.3-21.7,83-33.6,132.9-8.8,89,36.4,281.8,111.9,382.9,153.2,88,37.9,28.8,50.4,4.3,65.7ZM577.8,592.6c51.7-21.1,121.5-56,197.5-88.3V763.1S677,866.6,504.1,866.6c-186.2,0-286.7-103.5-286.7-103.5V521.5c58.7,23.7,124.6,44,204.3,71,49.1,17.4,111.50006,23.3,156.1.1Z",
    transform: "translate(-10.00503 -133.53251)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationsIc);
export default __webpack_public_path__ + "static/media/graduations-ic.75d5c7ae1c3dffe13b89b027d47f733f.svg";
export { ForwardRef as ReactComponent };